export default {"src":"/_next/static/media/x.1d2d655a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};